import {createActions} from 'client/framework';

export default createActions(null, [
  'DELETE_ASSIGNMENT',
  'SET_ASSIGNMENT_TO_DELETE',
  'SET_LAST_VALID_DATES',
  'INITIALIZE_TEACHER_AND_CLASSROOM_IDS'
]);
